/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './not-found.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../../app/not-found/not-found.component';
const styles_NotFoundComponent:any[] = [import0.styles];
export const RenderType_NotFoundComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_NotFoundComponent,
  data: {}
}
);
export function View_NotFoundComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    Color not found!!!!!!!!!!!\n']))
  ]
  ,(null as any),(null as any));
}
function View_NotFoundComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'color-not-found',([] as any[]),(null as any),(null as any),(null as any),View_NotFoundComponent_0,RenderType_NotFoundComponent)),
    import1.ɵdid(57344,(null as any),0,import2.NotFoundComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const NotFoundComponentNgFactory:import1.ComponentFactory<import2.NotFoundComponent> = import1.ɵccf('color-not-found',import2.NotFoundComponent,View_NotFoundComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRjovUHJvZ3JhbWFjaW9uL05vZGUvcHJveWVjdG9zL0FuZ3VsYXIyL21pcy1lamVtcGxvcy9Db2xvcmVzLUFuZ3VsYXI0LXJ1dGFzLWFuaWRhZGFzL3NyYy9hcHAvbm90LWZvdW5kL25vdC1mb3VuZC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRjovUHJvZ3JhbWFjaW9uL05vZGUvcHJveWVjdG9zL0FuZ3VsYXIyL21pcy1lamVtcGxvcy9Db2xvcmVzLUFuZ3VsYXI0LXJ1dGFzLWFuaWRhZGFzL3NyYy9hcHAvbm90LWZvdW5kL25vdC1mb3VuZC5jb21wb25lbnQudHMiLCJuZzovLy9GOi9Qcm9ncmFtYWNpb24vTm9kZS9wcm95ZWN0b3MvQW5ndWxhcjIvbWlzLWVqZW1wbG9zL0NvbG9yZXMtQW5ndWxhcjQtcnV0YXMtYW5pZGFkYXMvc3JjL2FwcC9ub3QtZm91bmQvbm90LWZvdW5kLmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRjovUHJvZ3JhbWFjaW9uL05vZGUvcHJveWVjdG9zL0FuZ3VsYXIyL21pcy1lamVtcGxvcy9Db2xvcmVzLUFuZ3VsYXI0LXJ1dGFzLWFuaWRhZGFzL3NyYy9hcHAvbm90LWZvdW5kL25vdC1mb3VuZC5jb21wb25lbnQudHMuTm90Rm91bmRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cD5cbiAgICBDb2xvciBub3QgZm91bmQhISEhISEhISEhIVxuPC9wPiIsIjxjb2xvci1ub3QtZm91bmQ+PC9jb2xvci1ub3QtZm91bmQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtJQUFHOzs7Ozs7SUNBSDtnQkFBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/not-found/not-found.component.ngfactory.ts